"use strict";
// (C) 2019-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBuckets = void 0;
var tslib_1 = require("tslib");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var bucketHelper_1 = require("../../../utils/bucketHelper");
var measureBucketItemsLimit = [
    {
        localIdentifier: sdk_ui_1.BucketNames.MEASURES,
        itemsLimit: 1,
    },
    {
        localIdentifier: sdk_ui_1.BucketNames.SECONDARY_MEASURES,
        itemsLimit: 1,
    },
];
exports.transformBuckets = function (buckets) {
    var bucketsWithLimitedMeasures = bucketHelper_1.limitNumberOfMeasuresInBuckets(buckets, 2, true);
    var measureBuckets = bucketHelper_1.transformMeasureBuckets(measureBucketItemsLimit, bucketsWithLimitedMeasures);
    var attributeBucket = {
        localIdentifier: sdk_ui_1.BucketNames.ATTRIBUTE,
        items: bucketHelper_1.getAllAttributeItems(buckets).slice(0, 1),
    };
    return tslib_1.__spreadArrays(measureBuckets, [attributeBucket]);
};
//# sourceMappingURL=bucketHelper.js.map